export enum BuyNumberStep {
  SELECT_NUMBER = 1,
  COMPLIANCE = 2,
  CONFIGURATION = 3,
}
export enum WhatsAppOption {
  ConnectApp = 'connect-app',
  ConnectWaba = 'connect-waba',
  NewPlivo = 'new-plivo',
}

export type WhatsAppOptionType = WhatsAppOption | null
